	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Node.GomlNode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Node/GomlNode.js
// module id = 127
// module chunks = 0